const WARNING_SEGUNDOS = 2 * 60; // deve bater com WARNING_MS do hook

export default function SessionTimeoutModal({ segundosRestantes, onContinuar, onSair }) {
    const minutos  = Math.floor(segundosRestantes / 60);
    const segundos = segundosRestantes % 60;
    const tempo    = minutos > 0
        ? `${minutos}:${String(segundos).padStart(2, "0")}`
        : `${segundos}s`;

    const urgente     = segundosRestantes <= 30;
    const progressoPct = Math.round((segundosRestantes / WARNING_SEGUNDOS) * 100);

    return (
        <div className="fixed inset-0 flex items-center justify-center z-[9999] px-4"
             style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-8 flex flex-col items-center gap-5">

                {/* Ícone */}
                <div className={`w-14 h-14 rounded-full flex items-center justify-center transition-colors ${urgente ? "bg-red-50" : "bg-yellow-50"}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className={`w-7 h-7 ${urgente ? "text-red-500" : "text-yellow-500"}`}
                         viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                         strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                    </svg>
                </div>

                {/* Texto */}
                <div className="text-center">
                    <h2 className="text-base font-bold text-gray-800">Sessão prestes a expirar</h2>
                    <p className="text-sm text-gray-500 mt-1">
                        Você será desconectado automaticamente por inatividade.
                    </p>
                </div>

                {/* Contagem */}
                <div className={`text-4xl font-mono font-bold tabular-nums transition-colors ${urgente ? "text-red-500" : "text-yellow-500"}`}>
                    {tempo}
                </div>

                {/* Barra de progresso */}
                <div className="w-full bg-gray-100 rounded-full h-1.5 overflow-hidden">
                    <div
                        className={`h-1.5 rounded-full transition-all duration-1000 ${urgente ? "bg-red-500" : "bg-yellow-400"}`}
                        style={{ width: `${progressoPct}%` }}
                    />
                </div>

                {/* Botões */}
                <div className="flex gap-3 w-full">
                    <button
                        onClick={onSair}
                        className="flex-1 py-2 text-sm font-semibold text-red-500 border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
                    >
                        Sair
                    </button>
                    <button
                        onClick={onContinuar}
                        className="flex-1 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
                    >
                        Continuar sessão
                    </button>
                </div>
            </div>
        </div>
    );
}
